import { combineSlices, createSlice } from '@reduxjs/toolkit'
import { Either } from 'effect'
import { createSelector } from 'reselect'

import { calculeCotisations } from '@/domaine/économie-collaborative/location-de-meublé'
import { SituationIncomplète } from '@/domaine/économie-collaborative/location-de-meublé/erreurs'
import { calculeRevenuNet } from '@/domaine/économie-collaborative/location-de-meublé/revenu-net'
import {
	estSituationValide,
	SituationLocationCourteDuree,
} from '@/domaine/économie-collaborative/location-de-meublé/situation'
import { RootState } from '@/store/reducers/rootReducer'

import locationDeMeubleReducer from './locationDeMeubleSlice'

export type SimulateurType =
	| 'location-de-meuble'
	| 'salarié'
	| 'indépendant'
	| 'auto-entrepreneur'
// ...

export interface SimulateursMetaState {
	simulateurActif: SimulateurType | null
}

const initialMetaState: SimulateursMetaState = {
	simulateurActif: null,
}

export const simulateursMetaSlice = createSlice({
	name: 'simulateurs/meta',
	initialState: initialMetaState,
	reducers: {
		activeLocationDeMeuble: (state) => {
			state.simulateurActif = 'location-de-meuble'
		},
		reset: (state) => {
			state.simulateurActif = null
		},
	},
})

export const { activeLocationDeMeuble, reset } = simulateursMetaSlice.actions

export const simulateursSlice = combineSlices({
	meta: simulateursMetaSlice.reducer,
	locationDeMeuble: locationDeMeubleReducer,
})

export const selectSimulateurActif = (state: RootState) =>
	state.simulateurs.meta.simulateurActif

export const selectEstLocationDeMeubleActif = (state: RootState) =>
	state.simulateurs.meta.simulateurActif === 'location-de-meuble'

export const selectLocationDeMeubleSituation = (
	state: RootState
): SituationLocationCourteDuree | null => {
	if (state.simulateurs.meta.simulateurActif !== 'location-de-meuble')
		return null

	return state.simulateurs.locationDeMeuble
}

export const selectLocationDeMeubleCotisations = createSelector(
	[selectLocationDeMeubleSituation],
	(situation) =>
		situation
			? calculeCotisations(situation)
			: Either.left(
					new SituationIncomplète({
						message: 'Impossible de calculer les cotisations du simulateur',
					})
			  )
)

export const selectLocationDeMeubleRevenuNet = createSelector(
	[selectLocationDeMeubleSituation],
	(situation) =>
		situation && estSituationValide(situation)
			? calculeRevenuNet(situation)
			: Either.left(
					new SituationIncomplète({
						message:
							'Impossible de calculer le revenu net sans connaitre les recettes',
					})
			  )
)

export default simulateursSlice
